// +----------------------------------------------------------------------
// | EB [ EB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.eb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed EB并不是自由软件，未经许可不能去掉EB相关版权
// +----------------------------------------------------------------------
// | Author: EB Team <admin@eb.com>
// +----------------------------------------------------------------------
import request from '@/api/request';

/**
 * @description 短信账户 -- 列表
 */
export function smsLstApi(data: any) {
  return request({
    url: 'sms/record',
    method: 'get',
    params: data,
  });
}

/**
 * @description 短信账户 -- 登录
 */
export function configApi(data: any) {
  return request({
    url: 'sms/config',
    method: 'post',
    data,
  });
}

/**
 * @description 短信账户 -- 修改密码
 */
export function changePsdApi(data: any) {
  return request({
    url: 'sms/change_password',
    method: 'post',
    data,
  });
}

/**
 * @description 短信账户 -- 修改签名
 */
export function changeSignApi(data: any) {
  return request({
    url: 'sms/change_sign',
    method: 'post',
    data,
  });
}

/**
 * @description 短信账户 -- 获取验证码
 */
export function captchaApi(data: any) {
  return request({
    url: 'serve/captcha',
    method: 'post',
    data,
  });
}

/**
 * @description 短信账户 -- 注册
 */
export function registerApi(data: any) {
  return request({
    url: 'serve/register',
    method: 'post',
    data,
  });
}

/**
 * @description 短信账户 -- 是否登录
 */
export function isLoginApi() {
  return request({
    url: 'serve/user/is_login',
    method: 'get',
  });
}

/**
 * @description 短信账户 -- 退出登录
 */
export function logoutApi() {
  return request({
    url: 'sms/logout',
    method: 'get',
  });
}

/**
 * @description 短信账户 -- 剩余条数
 */
export function smsNumberApi() {
  return request({
    url: 'sms/number',
    method: 'get',
  });
}

/**
 * @description 短信模板 -- 列表
 */
export function smsTempLstApi(data: any) {
  return request({
    url: 'serve/sms/temps',
    method: 'get',
    params: data,
  });
}

/**
 * @description 申请模板 -- 列表
 */
export function applyTempLstApi(data: any) {
  return request({
    url: 'serve/sms/apply_record',
    method: 'get',
    params: data,
  });
}

/**
 * @description 短信购买 -- 支付套餐
 */
export function smsPriceApi() {
  return request({
    url: 'sms/price',
    method: 'get',
  });
}

/**
 * @description 短信购买 -- 支付码
 */
export function payCodeApi(data: any) {
  return request({
    url: 'sms/pay_code',
    method: 'post',
    data,
  });
}

/**
 * @description 短信模板 -- 添加表单
 */
export function tempCreateApi(data: any) {
  return request({
    url: 'serve/sms/apply',
    method: 'post',
    data,
  });
}
